import { Component, Input } from '@angular/core';
import { FireAlarmComponentDto } from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-fire-alarm-component-info',
  templateUrl: './fire-alarm-component-info.component.html',
  styleUrls: ['./fire-alarm-component-info.component.scss']
})
export class FireAlarmComponentInfoInfoComponent {
  @Input()
  fireAlarmComponent: FireAlarmComponentDto = new FireAlarmComponentDto();
  @Input() columns = 2;

  constructor() {}
}
